export const BooleanTypeOptions = [
    { id: 0, text: 'No' },
    { id: 1, text: 'Yes' },
];
